var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 515.7 88.2",
    style: {
      enableBackground: "new 0 0 515.7 88.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#32F7A0;}\r\n\t.st2{fill:#FFFFFF;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "119.6,28.8 106.5,28.8 109,14.6 149.9,14.6 147.4,28.8 134.3,28.8 126.4,73.6 111.7,73.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "157.5,14.6 172.2,14.6 161.8,73.6 147.1,73.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "191.8,53.6 188.3,73.6 173.5,73.6 183.9,14.6 217.6,14.6 215.1,28.8 196.2,28.8 194.3,39.3  211.5,39.3 209,53.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M245.3,59.8c8.8,0,17.2-8.4,17.2-18.2c0-7.3-4.6-13.2-12-13.2c-8.8,0-17.1,8.5-17.1,18.3 C233.4,54,238,59.8,245.3,59.8 M252.1,13.7c15.3,0,25.8,11,25.8,26.4c0,18.7-15.8,34.5-34.1,34.5c-15.3,0-25.8-11-25.8-26.4 C218,29.5,233.9,13.7,252.1,13.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.7,28.4h-24.9c-9.2,0-17.3,8-17.3,18.4c0,7.3,4.3,13,12,13c5.5,0,11.8-3.8,12.8-10.1h-11.8l2.3-13.4h26.7 c0,0.3,0.1,1.9,0.1,2.4c0,18.5-11.4,35.8-32.1,35.8c-15.4,0-25.5-10.8-25.5-26.2c0-18.8,15.3-34.7,34.4-34.7h25.8"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M372.9,48.7l-2-14.8l-7.2,14.8 M356.3,62.9l-5.2,10.7H334l31.4-59h16.5l10.6,59h-15.9l-1.5-10.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "422.3,73.6 417.7,40.9 412,73.6 397.2,73.6 407.6,14.6 425.1,14.6 431.3,54.8 451.6,14.6 470.4,14.6  460,73.6 445.3,73.6 451.1,40.8 434.9,73.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "482.1,14.6 471.7,73.6 505.3,73.6 507.9,59.4 489,59.4 490.4,51 507.7,51 510.2,36.7 492.9,36.7  494.3,28.8 513.2,28.8 515.7,14.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,88.2c-2.8,0-5.4-1.6-6.5-4.3c-1.5-3.6,0.1-7.8,3.7-9.3L42.2,68l-25.9-5.5c-3.1-0.7-5.4-3.3-5.6-6.5 s1.8-6.1,4.8-7.1l23.8-8.2L6.2,36.5c-3.3-0.4-5.9-3.1-6.2-6.4c-0.3-3.3,1.7-6.4,4.9-7.4L73.6,0.3c3.7-1.2,7.7,0.8,8.9,4.5 s-0.8,7.7-4.5,8.9L39.4,26.4l31.9,4c3.3,0.4,5.8,3,6.2,6.3s-1.6,6.4-4.8,7.4l-28.4,9.8l22.8,4.8c3,0.6,5.3,3.2,5.6,6.2 s-1.4,6-4.3,7.2L32.2,87.6C31.3,88,30.4,88.2,29.5,88.2z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.91e3cebdeb6476fae062abc43f24a82e.svg";
export { ForwardRef as ReactComponent };